import React, { Component } from 'react'
import PropTypes from 'prop-types'
import track from 'react-tracking'
import WP from '@otavamedia/om-component-library/lib/lib/WP'
import { ErrorPlaceholder, withErrorBoundary } from '../../general/util/ErrorBoundaries'
import Timeline from '../../widgets/Timeline'
import './LatestPosts.scss'

@track({ gtmContext: ['LatestArticles'] })
class LatestPosts extends Component {
  static propTypes = {
    setRendered: PropTypes.func,
    compact: PropTypes.bool,
  }

  state = {
    latest: [],
    loading: true
  }

  async componentDidMount () {
    this.setState({ loading: true })
    const latest = await WP.getLatest()
    this.setState({
      loading: false,
      noMorePosts: !latest,
      latest,
      page: 1
    }, () => this.props.setRendered && this.props.setRendered(true))
  }

  async loadMore () {
    const { latest } = this.state
    const page = this.state.page + 1
    this.setState({ loading: true })
    const moreLatest = await WP.getLatest(0, page)
    this.setState({
      loading: false,
      noMorePosts: !moreLatest.length,
      latest: latest.concat(moreLatest),
      page
    })
  }

  render () {
    const { latest, noMorePosts, loading } = this.state
    const { compact } = this.props

    return latest
      ? <div styleName={'timeline' + (compact ? ' compact' : '')}>
        <Timeline title="Uusimmat" posts={latest} loading={loading} groupBy="date" compact noImages veryCompact={compact}
          url={compact ? '/uusimmat/' : null}
          dateOnly={true} loadMore={noMorePosts || compact ? null : this.loadMore.bind(this)}/>
      </div>
      : null
  }
}

export default withErrorBoundary(
  LatestPosts,
  ErrorPlaceholder()
)
